import { useContext } from "react";
import { createContext } from "react";

export const LayoutContent = createContext({})


export default function useLayout  () {
  return useContext(LayoutContent)
}